export default __webpack_public_path__ + "static/media/simple-order-account-management-vegshelf-marketplace.32ada6ba.png";